<div class="marker">
    <span class="marker__letter">{{letter}}</span>
    <span [ngClass]="{
        white: wordColor === 'white',
        blue: wordColor === 'blue',
        yellow: wordColor === 'yellow'
    }">{{word}}</span>
</div>
